// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   Subscription Components Styles
   ============================================================================ */

/* Pricing Page */
.pricing-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.pricing-header {
  text-align: center;
  margin-bottom: 3rem;
}

.pricing-header h1 {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 0.5rem;
}

.pricing-header p {
  color: #888;
  font-size: 1.1rem;
}

.pricing-error {
  background-color: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  color: #ef4444;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-top: 1rem;
  display: inline-block;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  align-items: stretch;
}

.pricing-card {
  background-color: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: transform 0.2s, border-color 0.2s;
}

.pricing-card:hover {
  transform: translateY(-4px);
  border-color: #444;
}

.pricing-card.highlighted {
  border-color: #218aff;
  box-shadow: 0 0 20px rgba(33, 138, 255, 0.2);
}

.pricing-card.current {
  border-color: #10b981;
}

.popular-badge,
.current-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.popular-badge {
  background-color: #218aff;
  color: #fff;
}

.current-badge {
  background-color: #10b981;
  color: #fff;
}

.pricing-card-header {
  text-align: center;
  margin-bottom: 1rem;
}

.pricing-card-header h2 {
  color: #fff;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.tier-description {
  color: #888;
  font-size: 0.9rem;
}

.pricing-card-price {
  text-align: center;
  margin-bottom: 1.5rem;
}

.pricing-card-price .price {
  font-size: 2.5rem;
  font-weight: 700;
  color: #fff;
}

.pricing-card-price .period {
  color: #888;
  font-size: 1rem;
}

.pricing-features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
  flex-grow: 1;
}

.pricing-features li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: #ccc;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
  text-align: left;
}

.pricing-features .check-icon {
  color: #10b981;
  font-weight: bold;
  flex-shrink: 0;
}

.pricing-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
}

.pricing-button:not(.current):not(:disabled) {
  background-color: #218aff;
  color: #fff;
}

.pricing-button:not(.current):not(:disabled):hover {
  background-color: #1a6fd1;
}

.pricing-button.current {
  background-color: transparent;
  border-color: #10b981;
  color: #10b981;
  cursor: default;
}

.pricing-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.manage-subscription-link {
  text-align: center;
  margin-top: 2rem;
  color: #888;
}

.link-button {
  background: none;
  border: none;
  color: #218aff;
  cursor: pointer;
  text-decoration: underline;
  font-size: inherit;
}

.link-button:hover {
  color: #1a6fd1;
}

/* Subscription Management */
.subscription-management {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
}

.subscription-header {
  text-align: center;
  margin-bottom: 2rem;
}

.subscription-header h1 {
  color: #fff;
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.subscription-header p {
  color: #888;
}

.subscription-error {
  background-color: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  color: #ef4444;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.subscription-card {
  background-color: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.subscription-info {
  margin-bottom: 1.5rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #333;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  color: #888;
}

.info-row .value {
  color: #fff;
  font-weight: 500;
}

.info-row .tier-name {
  font-size: 1.2rem;
  color: #218aff;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.85rem;
  text-transform: capitalize;
}

.status-active {
  background-color: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.status-trialing {
  background-color: rgba(33, 138, 255, 0.2);
  color: #218aff;
}

.status-warning {
  background-color: rgba(245, 158, 11, 0.2);
  color: #f59e0b;
}

.status-error {
  background-color: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.cancellation-notice {
  background-color: rgba(245, 158, 11, 0.1);
  border: 1px solid #f59e0b;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  color: #f59e0b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.warning-icon {
  font-size: 1.2rem;
}

/* Enhanced Cancellation Warning Box */
.cancellation-warning-box {
  background-color: rgba(239, 68, 68, 0.1);
  border: 2px solid #ef4444;
  border-radius: 12px;
  padding: 1.25rem;
  margin-top: 1.5rem;
}

.cancellation-warning-box .warning-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.cancellation-warning-box .warning-header .warning-icon {
  color: #ef4444;
  font-size: 1.5rem;
}

.cancellation-warning-box .warning-header h4 {
  color: #ef4444;
  margin: 0;
  font-size: 1.1rem;
}

.cancellation-warning-box .warning-date {
  color: #fff;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.cancellation-warning-box .warning-date strong {
  color: #ef4444;
}

.cancellation-warning-box .warning-details {
  color: #aaa;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  line-height: 1.4;
}

.cancellation-warning-box .reactivate-button {
  width: 100%;
  padding: 0.65rem 1rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid #10b981;
  background-color: transparent;
  color: #10b981;
}

.cancellation-warning-box .reactivate-button:hover {
  background-color: #10b981;
  color: #fff;
}

.cancellation-warning-box .reactivate-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.subscription-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.manage-button,
.upgrade-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  background-color: #218aff;
  color: #fff;
}

.manage-button:hover,
.upgrade-button:hover {
  background-color: #1a6fd1;
}

.manage-button:disabled,
.upgrade-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.refresh-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  background-color: transparent;
  border: 1px solid #333;
  color: #888;
}

.refresh-button:hover {
  border-color: #555;
  color: #fff;
}

.subscription-help {
  background-color: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 1.5rem;
}

.subscription-help h3 {
  color: #fff;
  margin-bottom: 0.75rem;
}

.subscription-help p {
  color: #888;
  margin-bottom: 0.5rem;
}

.subscription-help ul {
  color: #888;
  margin: 0.5rem 0 1rem 1.5rem;
}

.subscription-help li {
  margin-bottom: 0.25rem;
}

/* Result Pages (Success/Cancel) */
.subscription-result-page {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.result-card {
  background-color: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 2.5rem;
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.success-icon,
.cancel-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2.5rem;
}

.success-icon {
  background-color: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.cancel-icon {
  background-color: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.result-card h1 {
  color: #fff;
  font-size: 1.75rem;
  margin-bottom: 0.75rem;
}

.result-card > p {
  color: #888;
  margin-bottom: 1.5rem;
}

.result-details {
  background-color: #222;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.result-details p {
  color: #ccc;
  margin: 0;
}

.session-id {
  font-size: 0.8rem;
  color: #666 !important;
  margin-top: 0.5rem !important;
  font-family: monospace;
}

.redirect-notice {
  color: #888;
  margin-bottom: 1.5rem;
}

.result-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.primary-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  background-color: #218aff;
  color: #fff;
}

.primary-button:hover {
  background-color: #1a6fd1;
}

.secondary-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  background-color: transparent;
  border: 1px solid #333;
  color: #888;
}

.secondary-button:hover {
  border-color: #555;
  color: #fff;
}

/* Loading States */
.loading-container {
  text-align: center;
  padding: 3rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #333;
  border-top-color: #218aff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .pricing-grid {
    grid-template-columns: 1fr;
  }

  .pricing-page,
  .subscription-management {
    padding: 1rem;
  }

  .pricing-header h1 {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Subscription/SubscriptionStyles.css"],"names":[],"mappings":"AAAA;;iFAEiF;;AAEjF,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,wCAAwC;EACxC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ============================================================================\n   Subscription Components Styles\n   ============================================================================ */\n\n/* Pricing Page */\n.pricing-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.pricing-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.pricing-header h1 {\n  font-size: 2.5rem;\n  color: #fff;\n  margin-bottom: 0.5rem;\n}\n\n.pricing-header p {\n  color: #888;\n  font-size: 1.1rem;\n}\n\n.pricing-error {\n  background-color: rgba(239, 68, 68, 0.1);\n  border: 1px solid #ef4444;\n  color: #ef4444;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-top: 1rem;\n  display: inline-block;\n}\n\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  align-items: stretch;\n}\n\n.pricing-card {\n  background-color: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 12px;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  transition: transform 0.2s, border-color 0.2s;\n}\n\n.pricing-card:hover {\n  transform: translateY(-4px);\n  border-color: #444;\n}\n\n.pricing-card.highlighted {\n  border-color: #218aff;\n  box-shadow: 0 0 20px rgba(33, 138, 255, 0.2);\n}\n\n.pricing-card.current {\n  border-color: #10b981;\n}\n\n.popular-badge,\n.current-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.popular-badge {\n  background-color: #218aff;\n  color: #fff;\n}\n\n.current-badge {\n  background-color: #10b981;\n  color: #fff;\n}\n\n.pricing-card-header {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.pricing-card-header h2 {\n  color: #fff;\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.tier-description {\n  color: #888;\n  font-size: 0.9rem;\n}\n\n.pricing-card-price {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.pricing-card-price .price {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.pricing-card-price .period {\n  color: #888;\n  font-size: 1rem;\n}\n\n.pricing-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 1.5rem 0;\n  flex-grow: 1;\n}\n\n.pricing-features li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  color: #ccc;\n  font-size: 0.9rem;\n  margin-bottom: 0.75rem;\n  text-align: left;\n}\n\n.pricing-features .check-icon {\n  color: #10b981;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.pricing-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px solid transparent;\n}\n\n.pricing-button:not(.current):not(:disabled) {\n  background-color: #218aff;\n  color: #fff;\n}\n\n.pricing-button:not(.current):not(:disabled):hover {\n  background-color: #1a6fd1;\n}\n\n.pricing-button.current {\n  background-color: transparent;\n  border-color: #10b981;\n  color: #10b981;\n  cursor: default;\n}\n\n.pricing-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.manage-subscription-link {\n  text-align: center;\n  margin-top: 2rem;\n  color: #888;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  color: #218aff;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: inherit;\n}\n\n.link-button:hover {\n  color: #1a6fd1;\n}\n\n/* Subscription Management */\n.subscription-management {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.subscription-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.subscription-header h1 {\n  color: #fff;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.subscription-header p {\n  color: #888;\n}\n\n.subscription-error {\n  background-color: rgba(239, 68, 68, 0.1);\n  border: 1px solid #ef4444;\n  color: #ef4444;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n.subscription-card {\n  background-color: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.subscription-info {\n  margin-bottom: 1.5rem;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #333;\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-row .label {\n  color: #888;\n}\n\n.info-row .value {\n  color: #fff;\n  font-weight: 500;\n}\n\n.info-row .tier-name {\n  font-size: 1.2rem;\n  color: #218aff;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  text-transform: capitalize;\n}\n\n.status-active {\n  background-color: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.status-trialing {\n  background-color: rgba(33, 138, 255, 0.2);\n  color: #218aff;\n}\n\n.status-warning {\n  background-color: rgba(245, 158, 11, 0.2);\n  color: #f59e0b;\n}\n\n.status-error {\n  background-color: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.cancellation-notice {\n  background-color: rgba(245, 158, 11, 0.1);\n  border: 1px solid #f59e0b;\n  border-radius: 6px;\n  padding: 0.75rem 1rem;\n  color: #f59e0b;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.warning-icon {\n  font-size: 1.2rem;\n}\n\n/* Enhanced Cancellation Warning Box */\n.cancellation-warning-box {\n  background-color: rgba(239, 68, 68, 0.1);\n  border: 2px solid #ef4444;\n  border-radius: 12px;\n  padding: 1.25rem;\n  margin-top: 1.5rem;\n}\n\n.cancellation-warning-box .warning-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.cancellation-warning-box .warning-header .warning-icon {\n  color: #ef4444;\n  font-size: 1.5rem;\n}\n\n.cancellation-warning-box .warning-header h4 {\n  color: #ef4444;\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.cancellation-warning-box .warning-date {\n  color: #fff;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n}\n\n.cancellation-warning-box .warning-date strong {\n  color: #ef4444;\n}\n\n.cancellation-warning-box .warning-details {\n  color: #aaa;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n}\n\n.cancellation-warning-box .reactivate-button {\n  width: 100%;\n  padding: 0.65rem 1rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px solid #10b981;\n  background-color: transparent;\n  color: #10b981;\n}\n\n.cancellation-warning-box .reactivate-button:hover {\n  background-color: #10b981;\n  color: #fff;\n}\n\n.cancellation-warning-box .reactivate-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.subscription-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.manage-button,\n.upgrade-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  background-color: #218aff;\n  color: #fff;\n}\n\n.manage-button:hover,\n.upgrade-button:hover {\n  background-color: #1a6fd1;\n}\n\n.manage-button:disabled,\n.upgrade-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.refresh-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  background-color: transparent;\n  border: 1px solid #333;\n  color: #888;\n}\n\n.refresh-button:hover {\n  border-color: #555;\n  color: #fff;\n}\n\n.subscription-help {\n  background-color: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.subscription-help h3 {\n  color: #fff;\n  margin-bottom: 0.75rem;\n}\n\n.subscription-help p {\n  color: #888;\n  margin-bottom: 0.5rem;\n}\n\n.subscription-help ul {\n  color: #888;\n  margin: 0.5rem 0 1rem 1.5rem;\n}\n\n.subscription-help li {\n  margin-bottom: 0.25rem;\n}\n\n/* Result Pages (Success/Cancel) */\n.subscription-result-page {\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.result-card {\n  background-color: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 12px;\n  padding: 2.5rem;\n  text-align: center;\n  max-width: 500px;\n  width: 100%;\n}\n\n.success-icon,\n.cancel-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n  font-size: 2.5rem;\n}\n\n.success-icon {\n  background-color: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.cancel-icon {\n  background-color: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.result-card h1 {\n  color: #fff;\n  font-size: 1.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.result-card > p {\n  color: #888;\n  margin-bottom: 1.5rem;\n}\n\n.result-details {\n  background-color: #222;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.result-details p {\n  color: #ccc;\n  margin: 0;\n}\n\n.session-id {\n  font-size: 0.8rem;\n  color: #666 !important;\n  margin-top: 0.5rem !important;\n  font-family: monospace;\n}\n\n.redirect-notice {\n  color: #888;\n  margin-bottom: 1.5rem;\n}\n\n.result-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.primary-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  background-color: #218aff;\n  color: #fff;\n}\n\n.primary-button:hover {\n  background-color: #1a6fd1;\n}\n\n.secondary-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  background-color: transparent;\n  border: 1px solid #333;\n  color: #888;\n}\n\n.secondary-button:hover {\n  border-color: #555;\n  color: #fff;\n}\n\n/* Loading States */\n.loading-container {\n  text-align: center;\n  padding: 3rem;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #333;\n  border-top-color: #218aff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .pricing-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pricing-page,\n  .subscription-management {\n    padding: 1rem;\n  }\n\n  .pricing-header h1 {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
